import React from 'react';

const selectOptions = [
	'Ecommerce',
	'Photography',
	'Branding',
];

const ProjectsFilter = ({ setSelectProject }) => {
	return (
		<select
			onChange={(e) => {
				setSelectProject(e.target.value);
			}}
			className="font-general-medium 
                px-4
                sm:px-6
                py-2
                border
                dark:border-secondary-dark
                rounded-lg
                text-sm
                sm:text-md
                dark:font-medium
                bg-secondary-light
                dark:bg-ternary-dark
                text-primary-dark
                dark:text-ternary-light
            "
		>
			<option value="" className="text-sm sm:text-md">
				All Clients
			</option>

			{selectOptions.map((option) => (
				<option className="text-normal sm:text-md" key={option} value={option}>
					{option}
				</option>
			))}
		</select>
	);
};

export default ProjectsFilter;
